import React from 'react';
import { ModalNextProvider } from '@jutro/components';
import ModalCtrl from 'sg-modal-ctrl';
import { SgCvcService } from 'sg-capability-cvc';
import CommonConstants from 'sg-common-constants';
import _ from 'lodash';

const modalProps = {
    title: CommonConstants.CVC_UPDATE_ERROR_MODAL.TITLE,
    modalJsx: CommonConstants.CVC_UPDATE_ERROR_MODAL.MESSAGE,
    closeBtnLabel: CommonConstants.CVC_UPDATE_ERROR_MODAL.OK,
    titleVisibility: true
};

function updateCvcDetails(modelVM) {
    return new Promise((resolve) => {
        if (_.get(modelVM, 'ddaFormat.value.code') === undefined || _.get(modelVM, 'ddaFormat.value.code') === CommonConstants.DDA_FORMAT_CODE.NONE) {
            resolve();
            return;
        }
        SgCvcService.updatePolicyholderVulnerability(_.get(modelVM, 'quoteID.value'), _.get(modelVM, 'ddaFormat.value.code')).then((result) => {
            if (result === CommonConstants.RESPONSE.SUCCESS) {
                resolve();
            } else {
                ModalNextProvider.showModal(
                    <ModalCtrl {...modalProps} />
                ).then(() => {
                    resolve();
                });
            }
        });
    });
}

export default {
    updateCvcDetails
};
